import yearSituationResolver from './yearSituationResolver'


const savingsConfig = (montlySavings) => (obj, isSavingYear) => {
	return isSavingYear ? {
		...obj,
		yearSavings: montlySavings * 12
	} : {
		...obj,
		yearSavings: 0
	}
}

const totalCapitalConfig = (interest, montlySavings, initialCapital, INSSIncome) => (obj, previousMonthCapital, savingYear) => {
	if (savingYear) {
		if (!previousMonthCapital) {

			return {
				...obj,
				capital: (initialCapital * (1 + interest) + (montlySavings * 12)).toFixed(2)
			}
		}
		return {
			...obj,
			capital: (previousMonthCapital * (1 + interest) + (montlySavings * 12)).toFixed(2)
		}
	}
	return {
		...obj,
		capital: 0
	}
}

const injectEquityAfterwithdrawal = (obj, interest, previousCapital, previousEquityAfterWithdrawal, retiredYear) => {
	if (retiredYear) {
		if (!previousEquityAfterWithdrawal) {
			return {
				...obj,
				equityAfterWithdrawal: ((previousCapital * (1 + interest)) - obj.retiredSpending).toFixed(2)
			}
		}
		return {
			...obj,
			equityAfterWithdrawal: ((previousEquityAfterWithdrawal * (1 + interest)) - obj.retiredSpending).toFixed(2)
		}
	}
	return {
		...obj,
		equityAfterWithdrawal: 0
	}
}

const injectFinalEquity = (obj) => {
	const temp = obj.equityAfterWithdrawal > 0 ? obj.equityAfterWithdrawal : 0
	return {
		...obj,
		finalEquity: obj.capital || temp
	}
}


const retirementSpendingConfig = (retiredMontlySpending) => (obj, isRetired) => {
	return isRetired ? {
		...obj,
		spending: retiredMontlySpending * 12,
		retiredSpending: (retiredMontlySpending * 12 - obj.INSSIncome)
	} : {
		...obj,
		retiredSpending: 0,
		spending: 0
	}
}

const retirementINSSIncomeConfig = (inssIncome) => (obj, isRetired) => {
	return isRetired ? {
		...obj,
		INSSIncome: inssIncome * 12
	} : {
		...obj,
		INSSIncome: 0
	}
}

const validateField = (field) => {
	throw new Error(`Missing ${field}`)
}

export const generateTimeseriesMap = ({
																				age = validateField('age'), retirementAge = validateField('retirementAge'), lifeExpectancy = validateField('lifeExpectancy'), savingCapacity = validateField('savingCapacity'), totalInvestments = validateField('totalInvestments'), expectedInterest = validateField('expectedInterest'), INSSIncome = validateField('INSSIncome'), INSSage = validateField('INSSage'), retirementPlannedIncome = validateField('retirementPlannedIncome')
																			}) => {

	const yearResolver = new yearSituationResolver(age, retirementAge, lifeExpectancy, INSSage)

	const series = new Map()
	const interest = expectedInterest / 100

	const injectSavings = savingsConfig(savingCapacity)
	const injectRetiredSpending = retirementSpendingConfig(retirementPlannedIncome)
	const injectInnsIncome = retirementINSSIncomeConfig(INSSIncome)
	const injectCapital = totalCapitalConfig(interest, savingCapacity, totalInvestments)

	for (let i = age; i < lifeExpectancy + 1; i++) {
		let temp = {}
		const { retiredYear, savingYear, hasINSS } = yearResolver.getSituations(i)

		//resolves inss income
		temp = injectInnsIncome(temp, hasINSS)

		//resolve savings
		temp = injectSavings(temp, savingYear)

		//resolve retiredSpending
		temp = injectRetiredSpending(temp, retiredYear)

		//resolve capital
		const previousMonth = series.get(i - 1) || {
			capital: 0,
			retirementMontlySpending: 0
		}

		temp = injectCapital(temp, previousMonth.capital, savingYear, hasINSS)

		//resolve equity after withdrawal
		temp = injectEquityAfterwithdrawal(temp, interest, previousMonth.capital, previousMonth.equityAfterWithdrawal, retiredYear)

		//resolve yearEquity
		temp = injectFinalEquity(temp)

		series.set(i, temp)
	}
	return series
}




